import { Box, Flex, Heading } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeCreateChapterModel } from "../../../../modules/admin-modules/models/Actions";
import {
  createSubjectRequest,
  editSubjectRequest,
} from "../../../../modules/superadmin-modules/subjects/Actions";

const AddSubject = ({ isAdd, data, setSelectedData }) => {
  const openChapter = useSelector((state) => state.model.isOpen11);
  const isLoading = useSelector((state) => state.chapters.isLoading);

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة الفصل" : "تعديل  الفصل"}
      </Heading>
    </Box>
  );
  const onSubmit = async (values) => {
    console.log(values);
    const action = () => {
      dispatch(closeCreateChapterModel());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      dispatch(createSubjectRequest(values, action));
    } else {
      console.log("first");
      let formData = await new FormData();
      formData.append("_method", "PUT");

      const totel = { ...data, ...values };
      for (let key in totel) {
        if (key != "logo") formData.append(key, totel[key]);
      }

      dispatch(
        editSubjectRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeCreateChapterModel());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openChapter}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="اسم المادة  "
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="ادخل اسم المادة  "
              register={register}
              name="name"
            />
          </Box>

          {/* <Box w="45%">
            <FormLabel>رفع الصورة:</FormLabel>
            <Button
              bg="main_1"
              color="white"
              borderRadius="8px"
              textAlign="center"
              position="relative"
              w="100%"
            >
              <Text>{selected ? selected : "اختر ملف ليتم رفعه"} </Text>
              <Input
                onChange={(e) => {
                  setValue("logo", e.target.files[0]);
                  setSelected((s) => e.target.files[0].name);
                }}
                type="file"
                placeholder="اختر ملف ليتم رفعه"
                opacity="0"
                position="absolute"
                w="100%"
                h="100%"
              />
            </Button>
          </Box> */}
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddSubject;
